import { useEffect, useRef, useState, useCallback } from 'react';
import { gateway, type EventHandler } from '../gateway/connection';
import type { ConnectionStatus } from '../types/gateway';

export function useGateway() {
  const [status, setStatus] = useState<ConnectionStatus>('disconnected');
  const handlersRef = useRef<Set<EventHandler>>(new Set());

  useEffect(() => {
    const unsubStatus = gateway.onStatusChange(setStatus);
    gateway.connect();

    return () => {
      unsubStatus();
      gateway.disconnect();
    };
  }, []);

  const request = useCallback((method: string, params: Record<string, unknown>) => {
    return gateway.request(method, params);
  }, []);

  const send = useCallback((data: unknown) => {
    gateway.send(data);
  }, []);

  const onEvent = useCallback((handler: EventHandler) => {
    handlersRef.current.add(handler);
    const unsub = gateway.onEvent(handler);
    return () => {
      handlersRef.current.delete(handler);
      unsub();
    };
  }, []);

  // Legacy: onMessage wraps onEvent for backward compat
  const onMessage = useCallback((handler: (data: unknown) => void) => {
    return gateway.onMessage(handler);
  }, []);

  return { status, send, request, onEvent, onMessage };
}
